/** Centered spinner shown by Suspense while lazy-loaded pages load. */
export function PageLoader(): JSX.Element {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent-line" />
    </div>
  )
}
